'use client';

import { useContext } from 'react';
import { AnalyticsContext } from '../context/segment/AnalyticsContext';

/**
 * Analytics Context Hook
 */

export const useAnalytics = () => {
  const context = useContext(AnalyticsContext);
  if (!context) {
    throw new Error("useAnalytics hook must used within an AnalyticsProvider");
  }
  return context;
};